import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadSZLTFieldsValidationFailed, loadSZLTFieldsValidationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadSZLTFieldsValidation(action) {
  try {
    const {
      id,
      data,
    } = action.payload;
    const url = `${BACKEND_URL}/proxy/backend/api/v1/registries/order-services/${id}/fields-validation`;
    const dataResponse = yield makeRequest(url, data, action, 'POST', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadSZLTFieldsValidationSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadSZLTFieldsValidationFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadSZLTFieldsValidationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
